import Accordion from "components/Accordion";
import { Grid } from "modules/common/components/Grid";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { FAQ_ANCHOR } from "../../utils/consts";
import type { FAQProps } from "./FAQ.d";

export const FAQ = ({ title, accordionItems }: FAQProps) => (
  <Box id={FAQ_ANCHOR} py={{ base: 10, md: 20 }}>
    <Grid mb={0}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <Flex
          align={{ base: "flex-start", lg: "center" }}
          justify="space-between"
          flexDir={{ base: "column", lg: "row" }}
          pb={4}
        >
          <Heading variant="h2" as="h2" pb={4}>
            {title}
          </Heading>
        </Flex>
        {accordionItems?.length > 0 && <Accordion items={accordionItems} />}
      </Box>
    </Grid>
  </Box>
);
